import React from 'react'

import { defaultContext } from 'app/accountUserContextDefaultContext.ts'

export const AccountUserContext = React.createContext(defaultContext)
